import React, { useEffect, useState } from 'react';
import { ThemeProvider } from '@nimbus-ds/styles';
import { Box, Icon, IconButton, Tooltip } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import NavButtons from '../NavButtons/NavButtons';
import AppsList from '../AppsList/AppsList';
import { WhatsappIcon } from '@nimbus-ds/icons';
import { goTo, getSessionToken } from '@tiendanube/nexo';
import { useApiClient } from '../../hooks/useApiClient.hook';
import { ApiClientProvider } from '../../context';

type StoreInfo = { id: string; name: string; url: string; country?: string };
type NexoClient = Parameters<typeof getSessionToken>[0];
type GetStoreInfoFn = (nexo: NexoClient) => Promise<StoreInfo>;

const BaseLayout: React.FC<{
  children: React.ReactNode;
  appSlug?: string;
  getStoreInfo: GetStoreInfoFn;
  nexo: NexoClient;
}> = ({ children, appSlug, getStoreInfo, nexo }) => {
  const { t } = useTranslation();
  // The admin currently doesn't support dark mode. When it does, replace `base` value with `currentTheme` to provide dark mode support.

  const [message, setMessage] = useState<string>(
    `${t('BaseLayoutComponent.SupportMessage')}`,
  );

  useEffect(() => {
    const load = async () => {
      const store = await getStoreInfo(nexo);
      console.log('store', store);
      setMessage(`${t('BaseLayoutComponent.SupportMessage')} \n
        App: ${appSlug}
        Loja: ${store.name} (${store.id})
        URL: ${store.url}
      `);
    };
    load();
  }, []);

  const { AppApi, HuappsApi, apiLoading } = useApiClient({
    nexo,
    appSlug: process.env.REACT_APP_SLUG as string,
    appApiBaseUrl: process.env.REACT_APP_API_URI as string,
    huappsApiBaseUrl: process.env.REACT_APP_HUAPPS_API_URI as string,
    getStoreInfo,
    getSessionToken,
    goTo: (path: string) => goTo(nexo, path),
    toast: undefined,
  });

  if (!AppApi || !HuappsApi || apiLoading) return <div>loading..</div>;

  return (
    <ApiClientProvider AppApi={AppApi} HuappsApi={HuappsApi}>
      <ThemeProvider theme="base">
        <Box paddingBottom="20" marginBottom={'5'}>
          {children}

          <AppsList />

          <div style={{ position: 'fixed', bottom: '120px', right: '20px' }}>
            <Tooltip
              content={t('BaseLayoutComponent.SupportTooltip')}
              position="left"
            >
              <IconButton
                source={<Icon source={<WhatsappIcon size="large" />} />}
                onClick={() => {
                  window.open(
                    `https://wa.me/5514998812655?text=${encodeURIComponent(
                      message,
                    )}`,
                    '_blank',
                  );
                }}
                size="60px"
              />
            </Tooltip>
          </div>

          <NavButtons />
        </Box>
      </ThemeProvider>
    </ApiClientProvider>
  );
};

export default BaseLayout;
